import React, { useEffect, useState } from "react";

export const APP_CONFIRM_EVENT = "admin-confirm";

export const confirmAction = ({
  title = "Please confirm",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
}) => new Promise((resolve) => {
  if (typeof window === "undefined") {
    resolve(false);
    return;
  }

  window.dispatchEvent(new CustomEvent(APP_CONFIRM_EVENT, {
    detail: { title, message, confirmLabel, cancelLabel, destructive, resolve },
  }));
});

const ConfirmationModal = () => {
  const [confirmation, setConfirmation] = useState(null);

  useEffect(() => {
    const openConfirmation = (event) => setConfirmation(event.detail || null);
    window.addEventListener(APP_CONFIRM_EVENT, openConfirmation);
    return () => window.removeEventListener(APP_CONFIRM_EVENT, openConfirmation);
  }, []);

  const close = (accepted) => {
    confirmation?.resolve?.(accepted);
    setConfirmation(null);
  };

  if (!confirmation) return null;

  return <>
    <div className="modal show app-confirm-modal" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-modal="true" aria-labelledby="app-confirm-title" onClick={(event) => { if (event.target === event.currentTarget) close(false); }}>
      <div className="modal-dialog modal-dialog-centered"><div className="modal-content">
        <div className="modal-body">
          <span className={`app-confirm-icon ${confirmation.destructive ? "is-danger" : ""}`}><i className={`bi ${confirmation.destructive ? "bi-exclamation-triangle-fill" : "bi-question-circle-fill"}`} /></span>
          <h5 id="app-confirm-title">{confirmation.title}</h5>
          <p>{confirmation.message}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn app-confirm-cancel" onClick={() => close(false)}>{confirmation.cancelLabel}</button>
          <button type="button" className={`btn ${confirmation.destructive ? "app-confirm-danger" : "btn-primary"}`} onClick={() => close(true)}>{confirmation.confirmLabel}</button>
        </div>
      </div></div>
    </div>
    <div className="modal-backdrop fade show app-confirm-backdrop" onClick={() => close(false)} />
  </>;
};

export default ConfirmationModal;
